import { v4 as uuidv4 } from 'uuid';
import { reportError } from '@americanexpress/virtual-cards-commons';
import { ROUTE, MODULE_IDS, ERROR_LOG_MESSAGES } from '../utils/constants';

/**
 * onEnter hook that updates the user shallow identity session by calling
 * UpdateIdentitySession.v1. If the session is invalid
 * or the request fails, it redirects to an error page.
 */
const showAuthError = (replace) => {
  replace({
    pathname: ROUTE.ERROR,
    query: { errorType: 'auth_session_invalid' },
  });
};

const updateShallowIdentitySession = (store) => async (nextState, replace, callback) => {
  if (!global.BROWSER) {
    callback();
    return;
  }

  const { getState } = store;
  const oneDataCorrelationId = uuidv4();
  const faasApiUrl = getState().getIn(['config', 'faasApiUrl']);

  try {
    const readUserSession = await fetch(`${faasApiUrl}/UpdateIdentitySession.v1`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'ce-source': 'WEB',
        'Content-Type': 'application/json',
        'one-data-correlation-id': oneDataCorrelationId,
      },
      body: JSON.stringify({}),
    });

    // Only allow if status is 200, otherwise show auth error
    if (!readUserSession || readUserSession.status !== 200) {
      store.dispatch(reportError(
        new Error(`${ERROR_LOG_MESSAGES.UPDATE_SHALLOW_IDENTITY_SESSION_ERROR} ${readUserSession?.status}`),
        { collectionMethod: 'onEnter', moduleName: MODULE_IDS.UPDATE_SHALLOW_IDENTITY_SESSION, oneDataCorrelationId }
      ));
      showAuthError(replace);
      callback();
      return;
    }
  } catch (err) {
    // Network error or other fetch failure
    store.dispatch(reportError(err, {
      collectionMethod: 'onEnter',
      moduleName: MODULE_IDS.UPDATE_SHALLOW_IDENTITY_SESSION,
      oneDataCorrelationId,
    }));
    showAuthError(replace);
    callback();
    return;
  }
  callback();
};

export default updateShallowIdentitySession;
